import {
  createBox,
  createRestyleComponent,
  createVariant,
  VariantProps,
} from "@shopify/restyle";
import { Theme } from "app/Theme/Theme";

// * this is a view but we don't need to pass a style but only parameter
const MainBox = createBox<Theme>();

const Box = createRestyleComponent<
  VariantProps<Theme, "boxVariants"> & React.ComponentProps<typeof MainBox>,
  Theme
>([createVariant({ themeKey: "boxVariants" })], MainBox);

export { Box };
